module.exports = __webpack_public_path__ + "img/special_homeStarElimination.0c451aee.png";